/**
 * Toast Notification System
 * Replaces blocking alert() dialogs with non-blocking toast messages
 */

/**
 * Show a toast notification
 * @param {string} message - Message to display
 * @param {string} type - 'info', 'error', 'success', or 'warning'
 * @param {number} duration - Duration in milliseconds (default: 3000)
 */
export function showToast(message, type = 'info', duration = 3000) {
  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.textContent = message;
  document.body.appendChild(toast);

  // Trigger animation
  setTimeout(() => toast.classList.add('show'), 10);

  // Remove toast after duration
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, duration);
}

/**
 * Convenience methods for specific toast types
 */
export const toast = {
  error: (message, duration) => showToast(message, 'error', duration),
  success: (message, duration) => showToast(message, 'success', duration),
  warning: (message, duration) => showToast(message, 'warning', duration),
  info: (message, duration) => showToast(message, 'info', duration),
};
